export default __webpack_public_path__ + "static/media/skype.14689d30.svg";